import {
  CURRENCY_CONFIG,
  CURRENCY_SUFFIX_CODES,
  DEFAULT_CURRENCY_CODE,
} from "../constants/currencies.constants";

// Workers cannot import this file.
// Keep this config duplicated in dataDownloaderWorker.js and in sync.
export const formattedCurrencyValue = (value, currency) => {
  const currencyMeta =
    CURRENCY_CONFIG[currency] || CURRENCY_CONFIG[DEFAULT_CURRENCY_CODE];

  const currencyLanguage = currencyMeta.languageCode;
  const currencySymbol = currencyMeta.symbol;
  const isSuffixCurrency = CURRENCY_SUFFIX_CODES.includes(currency);

  if (!value) {
    return isSuffixCurrency
      ? `${value}${currencySymbol}`
      : `${currencySymbol}${value}`;
  }

  let formattedValue = parseFloat(value).toLocaleString(currencyLanguage, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (isSuffixCurrency) {
    return `${formattedValue}${currencySymbol}`;
  }

  return `${currencySymbol}${formattedValue}`;
};
